const handleTheme = (status: number) => {
    if(status === 0) return '#00FF00'
    if(status === 1) return '#00FFFF'
    if(status === 2) return '#FFFF00'
    if(status === 3) return '#FF99CC'
    if(status === 4) return '#FF0000'
    return '#ffffff'
}

export default handleTheme